import Comment from './comment'

export type { CommentProps, ReportCommentParams } from './comment'

export default Comment
